module.exports = __webpack_public_path__ + "img/IMG_0001_11.ffffc2c0.jpg";